export const USER_POPUP_HEIGHT = 760; // px, measured with devtools to ensure no y-scroll on init
